

/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as RequestBodyTypes from '../request-bodies/types'
import * as ResponseTypes from '../responses/types'
import * as SchemaTypes from '../schema/types'
import * as UtilityTypes from '../utilities/types'

import * as LoanTypeTypes from "./types"

export type CompanyLoanConfigurationsGetAllKey = ['companies',string | undefined,'loan-types',unknown];

export type CompanyLoanConfigurationsGetAllResponse = LoanTypeTypes.ResponseLoanConfigsPaging;

export type CompanyLoanConfigurationsGetAllVariables = {
    companyId: string | undefined;
    body?: void;
    query?: {
        startingAfter?: string;
        endingBefore?: string;
        reportingToAgency?: "experian" | "equifax" | "transUnion" | "innovis";
        sortBy?: Array<string>;
        offset?: number;
        /**
         * @default
         *     25
         */
        limit?: number;
        timezone?: string | null;
        include?: string;
        status?: Array<("active" | "inactive")>;
    };
}

export const companyLoanConfigurationsGetAll = makeData<
  CompanyLoanConfigurationsGetAllResponse,
  CompanyLoanConfigurationsGetAllKey,
  CompanyLoanConfigurationsGetAllVariables
>({
  method: 'get',
  name: 'companyLoanConfigurationsGetAll',
  summary: "Get loan types",
  path: '/companies/{companyId}/loan-types',
  queryKey: ({query, companyId,}) => ['companies',companyId,'loan-types', query],
})

export type CompanyLoanConfigurationsAddKey = ['companies',string | undefined,'loan-types',unknown];

export type CompanyLoanConfigurationsAddResponse = LoanTypeTypes.ResponseLoanType;

export type CompanyLoanConfigurationsAddVariables = {
    companyId: string | undefined;
    body?: LoanTypeTypes.RequestBodyLoanTypePost;
    query?: void;
}

export const companyLoanConfigurationsAdd = makeData<
  CompanyLoanConfigurationsAddResponse,
  CompanyLoanConfigurationsAddKey,
  CompanyLoanConfigurationsAddVariables
>({
  method: 'post',
  name: 'companyLoanConfigurationsAdd',
  summary: "Create loan type",
  path: '/companies/{companyId}/loan-types',
  queryKey: ({query, companyId,}) => ['companies',companyId,'loan-types', query],
})

export type CompanyLoanConfigurationsGetKey = ['companies',string | undefined,'loan-types',string | undefined,unknown];

export type CompanyLoanConfigurationsGetResponse = LoanTypeTypes.ResponseLoanType;

export type CompanyLoanConfigurationsGetVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        include?: string;
    };
}

export const companyLoanConfigurationsGet = makeData<
  CompanyLoanConfigurationsGetResponse,
  CompanyLoanConfigurationsGetKey,
  CompanyLoanConfigurationsGetVariables
>({
  method: 'get',
  name: 'companyLoanConfigurationsGet',
  summary: "Get loan type by ID",
  path: '/companies/{companyId}/loan-types/{loanTypeId}',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId, query],
})

export type CompanyLoanConfigurationsUpdateKey = ['companies',string | undefined,'loan-types',string | undefined,unknown];

export type CompanyLoanConfigurationsUpdateResponse = LoanTypeTypes.ResponseLoanType;

export type CompanyLoanConfigurationsUpdateVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: LoanTypeTypes.RequestBodyLoanTypeUpdate;
    query?: void;
}

export const companyLoanConfigurationsUpdate = makeData<
  CompanyLoanConfigurationsUpdateResponse,
  CompanyLoanConfigurationsUpdateKey,
  CompanyLoanConfigurationsUpdateVariables
>({
  method: 'put',
  name: 'companyLoanConfigurationsUpdate',
  summary: "Update loan type by ID",
  path: '/companies/{companyId}/loan-types/{loanTypeId}',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId, query],
})

export type CompanyLoanConfigurationsDeleteKey = ['companies',string | undefined,'loan-types',string | undefined,unknown];

export type CompanyLoanConfigurationsDeleteResponse = LoanTypeTypes.ResponseLoanType;

export type CompanyLoanConfigurationsDeleteVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        forceCancel?: "nonTerminal" | "all";
    };
}

export const companyLoanConfigurationsDelete = makeData<
  CompanyLoanConfigurationsDeleteResponse,
  CompanyLoanConfigurationsDeleteKey,
  CompanyLoanConfigurationsDeleteVariables
>({
  method: 'delete',
  name: 'companyLoanConfigurationsDelete',
  summary: "Delete loan type by ID",
  path: '/companies/{companyId}/loan-types/{loanTypeId}',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId, query],
})

export type LoanTypeBundleAddKey = ['companies',string | undefined,'loan-types','bundle',unknown];

export type LoanTypeBundleAddResponse = LoanTypeTypes.ResponseLoanTypeBundle;

export type LoanTypeBundleAddVariables = {
    companyId: string | undefined;
    body?: LoanTypeTypes.RequestBodyLoanTypeBundlePost;
    query?: void;
}

export const loanTypeBundleAdd = makeData<
  LoanTypeBundleAddResponse,
  LoanTypeBundleAddKey,
  LoanTypeBundleAddVariables
>({
  method: 'post',
  name: 'loanTypeBundleAdd',
  summary: "Create loan type and associated configs atomically",
  path: '/companies/{companyId}/loan-types/bundle',
  queryKey: ({query, companyId,}) => ['companies',companyId,'loan-types','bundle', query],
})

export type LoansGetByLoanTypeKey = ['companies',string | undefined,'loan-types',string | undefined,'loans',unknown];

export type LoansGetByLoanTypeResponse = SchemaTypes.LoansPaging;

export type LoansGetByLoanTypeVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        statuses?: Array<("all" | "active" | "pending" | "originated" | "declined" | "frozen" | "accelerated" | "chargedOff" | "paidOff" | "canceled")>;
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
        includeAdditionalBorrowers?: boolean;
    };
}

export const loansGetByLoanType = makeData<
  LoansGetByLoanTypeResponse,
  LoansGetByLoanTypeKey,
  LoansGetByLoanTypeVariables
>({
  method: 'get',
  name: 'loansGetByLoanType',
  summary: "Get all loans by loan type",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/loans',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'loans', query],
})

export type InternalLoanTypeIndexRateGetAllKey = ['companies',string | undefined,'loan-types',string | undefined,'index-rates',unknown];

export type InternalLoanTypeIndexRateGetAllResponse = ResponseTypes.IndexRatePaging;

export type InternalLoanTypeIndexRateGetAllVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        fromDate?: string;
        toDate?: string;
    };
}

export const internalLoanTypeIndexRateGetAll = makeData<
  InternalLoanTypeIndexRateGetAllResponse,
  InternalLoanTypeIndexRateGetAllKey,
  InternalLoanTypeIndexRateGetAllVariables
>({
  method: 'get',
  name: 'internalLoanTypeIndexRateGetAll',
  summary: "Get index interest rates",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/index-rates',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'index-rates', query],
})

export type InternalLoanTypeIndexRateAddKey = ['companies',string | undefined,'loan-types',string | undefined,'index-rates',unknown];

export type InternalLoanTypeIndexRateAddResponse = ResponseTypes.IndexRateResponse;

export type InternalLoanTypeIndexRateAddVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: RequestBodyTypes.IndexRateAdd;
    query?: void;
}

export const internalLoanTypeIndexRateAdd = makeData<
  InternalLoanTypeIndexRateAddResponse,
  InternalLoanTypeIndexRateAddKey,
  InternalLoanTypeIndexRateAddVariables
>({
  method: 'post',
  name: 'internalLoanTypeIndexRateAdd',
  summary: "Add index interest rate",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/index-rates',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'index-rates', query],
})

export type InternalLoanTypeIndexRateGetKey = ['companies',string | undefined,'loan-types',string | undefined,'index-rates',string | undefined,unknown];

export type InternalLoanTypeIndexRateGetResponse = ResponseTypes.IndexRateResponse;

export type InternalLoanTypeIndexRateGetVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    indexRateId: string | undefined;
    body?: void;
    query?: void;
}

export const internalLoanTypeIndexRateGet = makeData<
  InternalLoanTypeIndexRateGetResponse,
  InternalLoanTypeIndexRateGetKey,
  InternalLoanTypeIndexRateGetVariables
>({
  method: 'get',
  name: 'internalLoanTypeIndexRateGet',
  summary: "Get index interest rate by ID",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/index-rates/{indexRateId}',
  queryKey: ({query, companyId,
loanTypeId,
indexRateId,}) => ['companies',companyId,'loan-types',loanTypeId,'index-rates',indexRateId, query],
})

export type InternalLoanTypeIndexRateUpdateKey = ['companies',string | undefined,'loan-types',string | undefined,'index-rates',string | undefined,unknown];

export type InternalLoanTypeIndexRateUpdateResponse = ResponseTypes.IndexRateResponse;

export type InternalLoanTypeIndexRateUpdateVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    indexRateId: string | undefined;
    body?: RequestBodyTypes.IndexRateUpdate;
    query?: void;
}

export const internalLoanTypeIndexRateUpdate = makeData<
  InternalLoanTypeIndexRateUpdateResponse,
  InternalLoanTypeIndexRateUpdateKey,
  InternalLoanTypeIndexRateUpdateVariables
>({
  method: 'put',
  name: 'internalLoanTypeIndexRateUpdate',
  summary: "Update index interest rate",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/index-rates/{indexRateId}',
  queryKey: ({query, companyId,
loanTypeId,
indexRateId,}) => ['companies',companyId,'loan-types',loanTypeId,'index-rates',indexRateId, query],
})

export type InternalLoanTypeIndexRateDeleteKey = ['companies',string | undefined,'loan-types',string | undefined,'index-rates',string | undefined,unknown];

export type InternalLoanTypeIndexRateDeleteResponse = void;

export type InternalLoanTypeIndexRateDeleteVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    indexRateId: string | undefined;
    body?: void;
    query?: void;
}

export const internalLoanTypeIndexRateDelete = makeData<
  InternalLoanTypeIndexRateDeleteResponse,
  InternalLoanTypeIndexRateDeleteKey,
  InternalLoanTypeIndexRateDeleteVariables
>({
  method: 'delete',
  name: 'internalLoanTypeIndexRateDelete',
  summary: "Cancel index interest rate",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/index-rates/{indexRateId}',
  queryKey: ({query, companyId,
loanTypeId,
indexRateId,}) => ['companies',companyId,'loan-types',loanTypeId,'index-rates',indexRateId, query],
})

export type LoanTypeDynamicFeeGetAllKey = ['companies',string | undefined,'loan-types',string | undefined,'dynamic-fee-types',unknown];

export type LoanTypeDynamicFeeGetAllResponse = ResponseTypes.DynamicFeeTypePaging;

export type LoanTypeDynamicFeeGetAllVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        feeType?: "lateFee" | "modificationFee" | "serviceFee" | "membershipFee";
        sortBy?: Array<string>;
        offset?: number;
        /**
         * @default
         *     25
         */
        limit?: number;
    };
}

export const loanTypeDynamicFeeGetAll = makeData<
  LoanTypeDynamicFeeGetAllResponse,
  LoanTypeDynamicFeeGetAllKey,
  LoanTypeDynamicFeeGetAllVariables
>({
  method: 'get',
  name: 'loanTypeDynamicFeeGetAll',
  summary: "Get dynamic fees by loan type",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/dynamic-fee-types',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'dynamic-fee-types', query],
})

export type LoanTypeDynamicFeeTypeAddKey = ['companies',string | undefined,'loan-types',string | undefined,'dynamic-fee-types',unknown];

export type LoanTypeDynamicFeeTypeAddResponse = ResponseTypes.DynamicFeeType;

export type LoanTypeDynamicFeeTypeAddVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: RequestBodyTypes.DynamicFeeTypePost;
    query?: void;
}

export const loanTypeDynamicFeeTypeAdd = makeData<
  LoanTypeDynamicFeeTypeAddResponse,
  LoanTypeDynamicFeeTypeAddKey,
  LoanTypeDynamicFeeTypeAddVariables
>({
  method: 'post',
  name: 'loanTypeDynamicFeeTypeAdd',
  summary: "Create dynamic fee type",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/dynamic-fee-types',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'dynamic-fee-types', query],
})

export type LoanTypeDynamicFeeTypeGetKey = ['companies',string | undefined,'loan-types',string | undefined,'dynamic-fee-types',string | undefined,unknown];

export type LoanTypeDynamicFeeTypeGetResponse = ResponseTypes.DynamicFeeType;

export type LoanTypeDynamicFeeTypeGetVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    dynamicFeeTypeId: string | undefined;
    body?: void;
    query?: void;
}

export const loanTypeDynamicFeeTypeGet = makeData<
  LoanTypeDynamicFeeTypeGetResponse,
  LoanTypeDynamicFeeTypeGetKey,
  LoanTypeDynamicFeeTypeGetVariables
>({
  method: 'get',
  name: 'loanTypeDynamicFeeTypeGet',
  summary: "Get dynamic fee type by ID",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/dynamic-fee-types/{dynamicFeeTypeId}',
  queryKey: ({query, companyId,
loanTypeId,
dynamicFeeTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'dynamic-fee-types',dynamicFeeTypeId, query],
})

export type LoanTypeDynamicFeeTypeDeleteKey = ['companies',string | undefined,'loan-types',string | undefined,'dynamic-fee-types',string | undefined,unknown];

export type LoanTypeDynamicFeeTypeDeleteResponse = void;

export type LoanTypeDynamicFeeTypeDeleteVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    dynamicFeeTypeId: string | undefined;
    body?: void;
    query?: void;
}

export const loanTypeDynamicFeeTypeDelete = makeData<
  LoanTypeDynamicFeeTypeDeleteResponse,
  LoanTypeDynamicFeeTypeDeleteKey,
  LoanTypeDynamicFeeTypeDeleteVariables
>({
  method: 'delete',
  name: 'loanTypeDynamicFeeTypeDelete',
  summary: "Delete dynamic fee type",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/dynamic-fee-types/{dynamicFeeTypeId}',
  queryKey: ({query, companyId,
loanTypeId,
dynamicFeeTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'dynamic-fee-types',dynamicFeeTypeId, query],
})

export type LoanTypeDynamicFeeTypeMinPaymentLogicUpdateKey = ['companies',string | undefined,'loan-types',string | undefined,'dynamic-fee-types',string | undefined,'min-payment-logic',unknown];

export type LoanTypeDynamicFeeTypeMinPaymentLogicUpdateResponse = ResponseTypes.DynamicFeeType;

export type LoanTypeDynamicFeeTypeMinPaymentLogicUpdateVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    dynamicFeeTypeId: string | undefined;
    body?: LoanTypeTypes.RequestBodyDynamicFeeTypeMinPaymentLogicUpdate;
    query?: void;
}

export const loanTypeDynamicFeeTypeMinPaymentLogicUpdate = makeData<
  LoanTypeDynamicFeeTypeMinPaymentLogicUpdateResponse,
  LoanTypeDynamicFeeTypeMinPaymentLogicUpdateKey,
  LoanTypeDynamicFeeTypeMinPaymentLogicUpdateVariables
>({
  method: 'put',
  name: 'loanTypeDynamicFeeTypeMinPaymentLogicUpdate',
  summary: "Update dynamic fee type minPaymentLogic",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/dynamic-fee-types/{dynamicFeeTypeId}/min-payment-logic',
  queryKey: ({query, companyId,
loanTypeId,
dynamicFeeTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'dynamic-fee-types',dynamicFeeTypeId,'min-payment-logic', query],
})

export type InternalFeeTypesGetKey = ['companies',string | undefined,'loan-types',string | undefined,'fee-types',unknown];

export type InternalFeeTypesGetResponse = UtilityTypes.SingletonResponse & {
    data?: Array<{
        apiName?: SchemaTypes.FeeApiName;
        displayName?: SchemaTypes.FeeDisplayName;
    }>;
};

export type InternalFeeTypesGetVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: void;
}

export const internalFeeTypesGet = makeData<
  InternalFeeTypesGetResponse,
  InternalFeeTypesGetKey,
  InternalFeeTypesGetVariables
>({
  method: 'get',
  name: 'internalFeeTypesGet',
  summary: "Get fee types",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/fee-types',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'fee-types', query],
})

export type TransactionsGetLoansWithScheduledReversalsKey = ['companies',string | undefined,'loan-types',string | undefined,'scheduled-reversals',unknown];

export type TransactionsGetLoansWithScheduledReversalsResponse = {
    data?: Array<string>;
}

export type TransactionsGetLoansWithScheduledReversalsVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        scheduledBefore?: string;
    };
}

export const transactionsGetLoansWithScheduledReversals = makeData<
  TransactionsGetLoansWithScheduledReversalsResponse,
  TransactionsGetLoansWithScheduledReversalsKey,
  TransactionsGetLoansWithScheduledReversalsVariables
>({
  method: 'get',
  name: 'transactionsGetLoansWithScheduledReversals',
  summary: "Get all scheduled transactions",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/scheduled-reversals',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'scheduled-reversals', query],
})

export type TransactionsGetRawInternalHandlerKey = ['companies',string | undefined,'loan-types',string | undefined,'transactions',unknown];

export type TransactionsGetRawInternalHandlerResponse = ResponseTypes.TransactionCollection;

export type TransactionsGetRawInternalHandlerVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        status?: SchemaTypes.TransactionStatus;
        statuses?: Array<SchemaTypes.TransactionStatus>;
        scheduledBefore?: string;
        paymentType?: "ach" | "debitCard" | "creditCard";
        paymentTypes?: Array<("ach" | "debitCard" | "creditCard")>;
        autopayExpectedPaymentIds?: Array<string>;
        isExternal?: boolean;
    };
}

export const transactionsGetRawInternalHandler = makeData<
  TransactionsGetRawInternalHandlerResponse,
  TransactionsGetRawInternalHandlerKey,
  TransactionsGetRawInternalHandlerVariables
>({
  method: 'get',
  name: 'transactionsGetRawInternalHandler',
  summary: "Get all scheduled transactions",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/transactions',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'transactions', query],
})

export type FeeTypesGetKey = ['loan-types',string | undefined,'fee-types',unknown];

export type FeeTypesGetResponse = UtilityTypes.SingletonResponse & {
    data?: Array<{
        apiName?: SchemaTypes.FeeApiName;
        displayName?: SchemaTypes.FeeDisplayName;
    }>;
};

export type FeeTypesGetVariables = {
    loanTypeId: string | undefined;
    body?: void;
    query?: void;
}

export const feeTypesGet = makeData<
  FeeTypesGetResponse,
  FeeTypesGetKey,
  FeeTypesGetVariables
>({
  method: 'get',
  name: 'feeTypesGet',
  summary: "Get fee types",
  path: '/loan-types/{loanTypeId}/fee-types',
  queryKey: ({query, loanTypeId,}) => ['loan-types',loanTypeId,'fee-types', query],
})

export type GetLoanTypeCompanyConfigOverrideKey = ['companies',string | undefined,'loan-types',string | undefined,'company-config-override',unknown];

export type GetLoanTypeCompanyConfigOverrideResponse = LoanTypeTypes.LoanTypeCompanyConfigOverrideSubsetObject;

export type GetLoanTypeCompanyConfigOverrideVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        companyFallback?: boolean;
        paths?: string;
    };
}

export const getLoanTypeCompanyConfigOverride = makeData<
  GetLoanTypeCompanyConfigOverrideResponse,
  GetLoanTypeCompanyConfigOverrideKey,
  GetLoanTypeCompanyConfigOverrideVariables
>({
  method: 'get',
  name: 'getLoanTypeCompanyConfigOverride',
  summary: "Get loan type company override config",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/company-config-override',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'company-config-override', query],
})

export type SetLoanTypeCompanyConfigOverrideKey = ['companies',string | undefined,'loan-types',string | undefined,'company-config-override',unknown];

export type SetLoanTypeCompanyConfigOverrideResponse = void;

export type SetLoanTypeCompanyConfigOverrideVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: LoanTypeTypes.LoanTypeCompanyConfigOverrideSubsetObject;
    query?: {
        paths?: string;
    };
}

export const setLoanTypeCompanyConfigOverride = makeData<
  SetLoanTypeCompanyConfigOverrideResponse,
  SetLoanTypeCompanyConfigOverrideKey,
  SetLoanTypeCompanyConfigOverrideVariables
>({
  method: 'put',
  name: 'setLoanTypeCompanyConfigOverride',
  summary: "Update loan type company override config",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/company-config-override',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'company-config-override', query],
})

export type GetLoanTypeChargedoffPaidoffPeriodsWithoutStatementsKey = ['companies',string | undefined,'loan-types',string | undefined,'paidoff-chargedoff-periods-without-statements',unknown];

export type GetLoanTypeChargedoffPaidoffPeriodsWithoutStatementsResponse = UtilityTypes.Paging & {
    data?: SchemaTypes.LoanPeriod & {
        loanId?: string;
        mainBorrowerId?: string;
        terminalStatus?: SchemaTypes.LoanStatus;
        previousPeriodId?: string;
        previousPeriodTerminalStatus?: SchemaTypes.LoanStatus;
    };
};

export type GetLoanTypeChargedoffPaidoffPeriodsWithoutStatementsVariables = {
    companyId: string | undefined;
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        statementDate: string;
    };
}

export const getLoanTypeChargedoffPaidoffPeriodsWithoutStatements = makeData<
  GetLoanTypeChargedoffPaidoffPeriodsWithoutStatementsResponse,
  GetLoanTypeChargedoffPaidoffPeriodsWithoutStatementsKey,
  GetLoanTypeChargedoffPaidoffPeriodsWithoutStatementsVariables
>({
  method: 'get',
  name: 'getLoanTypeChargedoffPaidoffPeriodsWithoutStatements',
  summary: "Get periods whose terminal state is `paidOff`/`chargedOff` and do not have statements",
  path: '/companies/{companyId}/loan-types/{loanTypeId}/paidoff-chargedoff-periods-without-statements',
  queryKey: ({query, companyId,
loanTypeId,}) => ['companies',companyId,'loan-types',loanTypeId,'paidoff-chargedoff-periods-without-statements', query],
})

export type LoanTypeIndexRateGetAllKey = ['loan-types',string | undefined,'index-rates',unknown];

export type LoanTypeIndexRateGetAllResponse = ResponseTypes.IndexRatePaging;

export type LoanTypeIndexRateGetAllVariables = {
    loanTypeId: string | undefined;
    body?: void;
    query?: {
        fromDate?: string;
        toDate?: string;
    };
}

export const loanTypeIndexRateGetAll = makeData<
  LoanTypeIndexRateGetAllResponse,
  LoanTypeIndexRateGetAllKey,
  LoanTypeIndexRateGetAllVariables
>({
  method: 'get',
  name: 'loanTypeIndexRateGetAll',
  summary: "Get index interest rates",
  path: '/loan-types/{loanTypeId}/index-rates',
  queryKey: ({query, loanTypeId,}) => ['loan-types',loanTypeId,'index-rates', query],
})

export type LoanTypeIndexRateAddKey = ['loan-types',string | undefined,'index-rates',unknown];

export type LoanTypeIndexRateAddResponse = ResponseTypes.IndexRateResponse;

export type LoanTypeIndexRateAddVariables = {
    loanTypeId: string | undefined;
    body?: RequestBodyTypes.IndexRateAdd;
    query?: void;
}

export const loanTypeIndexRateAdd = makeData<
  LoanTypeIndexRateAddResponse,
  LoanTypeIndexRateAddKey,
  LoanTypeIndexRateAddVariables
>({
  method: 'post',
  name: 'loanTypeIndexRateAdd',
  summary: "Add index interest rate",
  path: '/loan-types/{loanTypeId}/index-rates',
  queryKey: ({query, loanTypeId,}) => ['loan-types',loanTypeId,'index-rates', query],
})

export type LoanTypeIndexRateGetKey = ['loan-types',string | undefined,'index-rates',string | undefined,unknown];

export type LoanTypeIndexRateGetResponse = ResponseTypes.IndexRateResponse;

export type LoanTypeIndexRateGetVariables = {
    loanTypeId: string | undefined;
    indexRateId: string | undefined;
    body?: void;
    query?: void;
}

export const loanTypeIndexRateGet = makeData<
  LoanTypeIndexRateGetResponse,
  LoanTypeIndexRateGetKey,
  LoanTypeIndexRateGetVariables
>({
  method: 'get',
  name: 'loanTypeIndexRateGet',
  summary: "Get index interest rate by ID",
  path: '/loan-types/{loanTypeId}/index-rates/{indexRateId}',
  queryKey: ({query, loanTypeId,
indexRateId,}) => ['loan-types',loanTypeId,'index-rates',indexRateId, query],
})

export type LoanTypeIndexRateUpdateKey = ['loan-types',string | undefined,'index-rates',string | undefined,unknown];

export type LoanTypeIndexRateUpdateResponse = ResponseTypes.IndexRateResponse;

export type LoanTypeIndexRateUpdateVariables = {
    loanTypeId: string | undefined;
    indexRateId: string | undefined;
    body?: RequestBodyTypes.IndexRateUpdate;
    query?: void;
}

export const loanTypeIndexRateUpdate = makeData<
  LoanTypeIndexRateUpdateResponse,
  LoanTypeIndexRateUpdateKey,
  LoanTypeIndexRateUpdateVariables
>({
  method: 'put',
  name: 'loanTypeIndexRateUpdate',
  summary: "Update index interest rate",
  path: '/loan-types/{loanTypeId}/index-rates/{indexRateId}',
  queryKey: ({query, loanTypeId,
indexRateId,}) => ['loan-types',loanTypeId,'index-rates',indexRateId, query],
})

export type LoanTypeIndexRateDeleteKey = ['loan-types',string | undefined,'index-rates',string | undefined,unknown];

export type LoanTypeIndexRateDeleteResponse = void;

export type LoanTypeIndexRateDeleteVariables = {
    loanTypeId: string | undefined;
    indexRateId: string | undefined;
    body?: void;
    query?: void;
}

export const loanTypeIndexRateDelete = makeData<
  LoanTypeIndexRateDeleteResponse,
  LoanTypeIndexRateDeleteKey,
  LoanTypeIndexRateDeleteVariables
>({
  method: 'delete',
  name: 'loanTypeIndexRateDelete',
  summary: "Cancel index interest rate",
  path: '/loan-types/{loanTypeId}/index-rates/{indexRateId}',
  queryKey: ({query, loanTypeId,
indexRateId,}) => ['loan-types',loanTypeId,'index-rates',indexRateId, query],
})
